import Sparkle from "../../assets/icons/sparkle.svg";

import Web1 from "../../assets/images/works/jihan-duerme-featured-works-dsa.png";
import Web2 from "../../assets/images/works/jihan-duerme-featured-works-mh.png";
import Web3 from "../../assets/images/works/jihan-duerme-featured-works-ra.png";
import Web4 from "../../assets/images/works/jihan-duerme-featured-works-eco.png";

function Web() {
    return (
        <section className="featured-work">
            {/* Section Title */}
            <header className="d-flex mb-4 mb-md-5">
                <img src={Sparkle} alt="Sparkle" />
                <h2>Website Work</h2>
            </header>

            <section className="work-cards">
                {/* Web 1 */}
                <a href="https://dsarch.com.au/" target="_blank" rel="noreferrer">
                    <article>
                        <div className="work-card-details">
                            <h3>DS Architects</h3>
                            <p>Connecting with new audiences in the education, private and public sectors.</p>
                        </div>
                        <img src={Web1} alt="DS Architects Website" />
                    </article>
                </a>

                {/* Web 2 */}
                <a href="https://meganhounslow.com/" target="_blank" rel="noreferrer">
                    <article>
                        <div className="work-card-details">
                            <h3>Megan Hounslow</h3>
                            <p>Brand repositioning of an interior designerto reflect a calm, luxurious style.</p>
                        </div>
                        <img src={Web2} alt="Megan Hounslow Website" />
                    </article>
                </a>

                {/* Web 3 */}
                <a href="https://rarchitecture.com.au/" target="_blank" rel="noreferrer">
                    <article>
                        <div className="work-card-details">
                            <h3>R Architecture</h3>
                            <p>Showcasing projects contributed to their community in the last 10 years.</p>
                        </div>
                        <img src={Web3} alt="R Architecture Website" />
                    </article>
                </a>

                {/* Web 4 */}
                <a href="https://ecotracker.io/" target="_blank" rel="noreferrer">
                    <article>
                        <div className="work-card-details">
                            <h3>Ecotracker</h3>
                            <p>Providing insights into their environmental impact and customer behavior.</p>
                        </div>
                        <img src={Web4} alt="Ecotracker Website" />
                    </article>
                </a>
            </section>
        </section>
    );
};

export default Web;